import {useMemo} from 'react';
import {nodesFromEdges} from '@shopify/admin-graphql-api-utilities';
import {useQuery} from '@shopify/react-graphql';

import ResourcePreviewQuery, {
  ResourcePreviewQueryQueryData,
} from './graphql/ResourcePreviewQuery.graphql';

export interface Props {
  resourceIds?: string[];
  filenames?: string[];
}

export interface FilesPreview {
  nodes: (
    | ResourcePreviewQueryQueryData.NodesGenericFile
    | ResourcePreviewQueryQueryData.NodesMediaImage
    | ResourcePreviewQueryQueryData.NodesVideo
    | ResourcePreviewQueryQueryData.NodesOther
  )[];
  files: (
    | ResourcePreviewQueryQueryData.FilesEdgesNodeGenericFile
    | ResourcePreviewQueryQueryData.FilesEdgesNodeMediaImage
    | ResourcePreviewQueryQueryData.FilesEdgesNodeVideo
    | ResourcePreviewQueryQueryData.FilesEdgesNodeOther
  )[];
  loading: boolean;
}

export const useFilesPreview = ({
  resourceIds = [],
  filenames = [],
}: Props): FilesPreview => {
  const {data, loading} = useQuery(ResourcePreviewQuery, {
    variables: {
      shouldFetchNodes: resourceIds.length > 0,
      shouldFetchFiles: filenames.length > 0,
      ids: resourceIds,
      query: `filename:'${filenames.join("' OR filename:'")}'`,
      first: filenames.length,
    },
    skip: resourceIds.length === 0 && filenames.length === 0,
  });

  return useMemo(
    () => ({
      nodes: data?.nodes || [],
      files: nodesFromEdges(data?.files?.edges || []),
      loading,
    }),
    [data, loading],
  );
};
